import PropTypes from 'prop-types'
import React, { Component } from 'react'

import TwitterButton from '../../../components/social/twitter_button.jsx'
import FacebookButton from '../../../components/social/facebook_button.jsx'
import PinterestButton from '../../../components/social/pinterest_button.jsx'

import styles from './share_social.scss'

class shareSocial extends Component {

	constructor(props) {
		super(props)
		this.onSelectTwitter = this.props.onSelect.bind(this, 'Twitter')
		this.onSelectFacebook = this.props.onSelect.bind(this, 'Facebook')
		this.onSelectPinterest = this.props.onSelect.bind(this, 'Pinterest')
	}

	shouldComponentUpdate(nextProps) {
		return nextProps.visibleTab !== this.props.visibleTab
	}

	render() {
		return (
			<div className={styles.social_area}>
				<div className={styles.social_area_item}>
					<TwitterButton
						customClass='light'
						dataObject={this.props.dataObject.twitter}
						onSelect={this.onSelectTwitter}
					/>
				</div>
				<div className={styles.social_area_item}>
					<FacebookButton
						customClass='light'
						dataObject={this.props.dataObject.facebook}
						onSelect={this.onSelectFacebook}
					/>
				</div>
				{this.props.dataObject.pinterest &&
					<div className={styles.social_area_item}>
						<PinterestButton
							customClass='light'
							dataObject={this.props.dataObject.pinterest}
							onSelect={this.onSelectPinterest}
						/>
					</div>
				}
			</div>
		)
	}

}

shareSocial.defaultProps = {
	onSelect: () => {},
}

shareSocial.propTypes = {
	dataObject: PropTypes.object,
	visibleTab: PropTypes.bool,
	onSelect: PropTypes.func,
}

export default shareSocial
